import { Component } from '@angular/core';

@Component({
  selector: 'app-blocked-modal2',
  standalone: true,
  imports: [],
  templateUrl: './blocked-modal2.component.html',
  styleUrl: './blocked-modal2.component.css'
})
export class BlockedModal2Component {

}
